/* ═══════════════════════════════════════════════════════════
 *  OUTFIT — Données de l'application
 *  Inclut : looks, garde-robe étendue, articles partenaires
 *           avec images (URLs placeholder Unsplash-style)
 * ═══════════════════════════════════════════════════════════ */

export const occasions = [
  { id: 'soiree', label: 'Soirée',  icon: '🌙' },
  { id: 'diner',  label: 'Dîner',   icon: '🍷' },
  { id: 'sortie', label: 'Sortie',  icon: '✨' },
  { id: 'work',   label: 'Bureau',  icon: '💼' },
  { id: 'casual', label: 'Casual',  icon: '☀️' },
  { id: 'sport',  label: 'Sport',   icon: '🏃' },
];

/* ─── Articles partenaires avec images ─────────────────────── */
export const partnerProducts = [
  /* ZALANDO */
  { id: 'pp1', emoji: '👗', name: 'Robe midi plissée', brand: 'Zalando', partner: 'zalando',
    price: 89, color: 'Noir', category: 'Robes', size: ['34','36','38','40'],
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=300&q=80',
    available: true, deliveryDays: '2–4 j' },
  { id: 'pp2', emoji: '👠', name: 'Escarpins stiletto', brand: 'Zalando', partner: 'zalando',
    price: 65, color: 'Nude', category: 'Chaussures', size: ['36','37','38','39','40'],
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=300&q=80',
    available: true, deliveryDays: '2–4 j' },
  { id: 'pp3', emoji: '👜', name: 'Sac cabas cuir', brand: 'Zalando', partner: 'zalando',
    price: 129, color: 'Camel', category: 'Sacs', size: ['Unique'],
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=300&q=80',
    available: true, deliveryDays: '2–4 j' },

  /* ASOS */
  { id: 'pp4', emoji: '👟', name: 'Sneakers cuir blanc', brand: 'ASOS', partner: 'asos',
    price: 55, color: 'Blanc', category: 'Chaussures', size: ['36','37','38','39','40','41'],
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },
  { id: 'pp5', emoji: '💍', name: 'Collier chaîne fine', brand: 'ASOS', partner: 'asos',
    price: 22, color: 'Or', category: 'Bijoux', size: ['Unique'],
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=300&q=80',
    available: false, deliveryDays: '3–5 j' },
  { id: 'pp6', emoji: '🧥', name: 'Trench coat beige', brand: 'ASOS', partner: 'asos',
    price: 89, color: 'Beige', category: 'Vestes', size: ['34','36','38','40'],
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },

  /* NET-A-PORTER */
  { id: 'pp7', emoji: '👗', name: 'Robe soirée satin', brand: 'Net-a-Porter', partner: 'net_a_porter',
    price: 480, color: 'Noir', category: 'Robes', size: ['34','36','38','40'],
    image: 'https://images.unsplash.com/photo-1623609163859-ca93c959b98a?w=300&q=80',
    available: true, deliveryDays: '1–2 j' },
  { id: 'pp8', emoji: '👜', name: 'Pochette clutch dorée', brand: 'Net-a-Porter', partner: 'net_a_porter',
    price: 340, color: 'Or', category: 'Sacs', size: ['Unique'],
    image: 'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=300&q=80',
    available: true, deliveryDays: '1–2 j' },

  /* FARFETCH */
  { id: 'pp9', emoji: '🕶️', name: 'Lunettes cat-eye', brand: 'Farfetch', partner: 'farfetch',
    price: 195, color: 'Noir', category: 'Accessoires', size: ['Unique'],
    image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=300&q=80',
    available: true, deliveryDays: '2–4 j' },
  { id: 'pp10', emoji: '🧣', name: 'Écharpe cashmere', brand: 'Farfetch', partner: 'farfetch',
    price: 220, color: 'Camel', category: 'Accessoires', size: ['Unique'],
    image: 'https://images.unsplash.com/photo-1601924582970-9238bcb495d9?w=300&q=80',
    available: true, deliveryDays: '2–4 j' },

  /* H&M */
  { id: 'pp11', emoji: '👚', name: 'Top basique coton', brand: 'H&M', partner: 'hm',
    price: 15, color: 'Blanc', category: 'Hauts', size: ['XS','S','M','L'],
    image: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },
  { id: 'pp12', emoji: '👖', name: 'Jean slim taille haute', brand: 'H&M', partner: 'hm',
    price: 35, color: 'Bleu', category: 'Bas', size: ['34','36','38','40'],
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },

  /* MANGO */
  { id: 'pp13', emoji: '🧥', name: 'Blazer structuré', brand: 'Mango', partner: 'mango',
    price: 79, color: 'Beige', category: 'Vestes', size: ['34','36','38','40','42'],
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4571?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },
  { id: 'pp14', emoji: '👠', name: 'Mules à talon', brand: 'Mango', partner: 'mango',
    price: 49, color: 'Marron', category: 'Chaussures', size: ['36','37','38','39','40'],
    image: 'https://images.unsplash.com/photo-1551107696-a4b0c5a0d9a2?w=300&q=80',
    available: true, deliveryDays: '3–5 j' },
];

/* ─── Garde-robe existante étendue ─────────────────────────── */
export const wardrobe = [
  { id: 'w1',  emoji: '👗', name: 'Robe noire satin',    category: 'Robes',       style: 'Soirée',  color: 'Noir',     brand: 'Sézane',     image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=200&q=80' },
  { id: 'w2',  emoji: '🧥', name: 'Blazer structuré',    category: 'Vestes',      style: 'Chic',    color: 'Noir',     brand: 'Zara',       image: null },
  { id: 'w3',  emoji: '👠', name: 'Escarpins aiguille',  category: 'Chaussures',  style: 'Soirée',  color: 'Nude',     brand: 'Zalando',    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=200&q=80' },
  { id: 'w4',  emoji: '👖', name: 'Pantalon tailleur',   category: 'Bas',         style: 'Bureau',  color: 'Camel',    brand: 'Mango',      image: null },
  { id: 'w5',  emoji: '🧣', name: 'Foulard en soie',     category: 'Accessoires', style: 'Casual',  color: 'Bordeaux', brand: 'H&M',        image: null },
  { id: 'w6',  emoji: '👜', name: 'Pochette dorée',      category: 'Sacs',        style: 'Soirée',  color: 'Or',       brand: 'ASOS',       image: null },
  { id: 'w7',  emoji: '🥻', name: 'Robe fluide ivoire',  category: 'Robes',       style: 'Dîner',   color: 'Ivoire',   brand: 'Sézane',     image: 'https://images.unsplash.com/photo-1623609163859-ca93c959b98a?w=200&q=80' },
  { id: 'w8',  emoji: '👟', name: 'Sneakers blanches',   category: 'Chaussures',  style: 'Casual',  color: 'Blanc',    brand: 'ASOS',       image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&q=80' },
  { id: 'w9',  emoji: '🧤', name: 'Gants cuir noir',     category: 'Accessoires', style: 'Soirée',  color: 'Noir',     brand: 'Zara',       image: null },
  { id: 'w10', emoji: '💍', name: 'Bague dorée fine',    category: 'Bijoux',      style: 'Tout',    color: 'Or',       brand: 'Mango',      image: null },
  { id: 'w11', emoji: '👚', name: 'Top en soie écru',    category: 'Hauts',       style: 'Casual',  color: 'Écru',     brand: 'Sézane',     image: null },
  { id: 'w12', emoji: '🧥', name: 'Manteau camel',       category: 'Vestes',      style: 'Tout',    color: 'Camel',    brand: 'Zara',       image: null },
  { id: 'w13', emoji: '👖', name: 'Jean slim noir',      category: 'Bas',         style: 'Casual',  color: 'Noir',     brand: 'ASOS',       image: null },
  { id: 'w14', emoji: '💄', name: 'Pochette velours',    category: 'Sacs',        style: 'Soirée',  color: 'Bordeaux', brand: 'Mango',      image: null },
];

export const wardrobeCategories = ['Tout', 'Robes', 'Hauts', 'Vestes', 'Manteaux', 'Bas', 'Maillots', 'Chaussures', 'Sacs', 'Accessoires', 'Bijoux'];

/* ─── Looks avec articles partenaires ──────────────────────── */
export const looks = [
  {
    id: '1', name: 'Élégance absolue', tag: 'Soirée de gala',
    score: 96, occasion: 'soiree', totalPrice: 517, missingPrice: 388,
    items: [
      { id: 'i1', emoji: '👗', label: 'Robe',      owned: true,  price: 0,   brand: 'Sézane',       wardrobeId: 'w1', partnerProductId: null },
      { id: 'i2', emoji: '💎', label: 'Bijou',     owned: false, price: 22,  brand: 'ASOS',         wardrobeId: null, partnerProductId: 'pp5' },
      { id: 'i3', emoji: '👠', label: 'Escarpins', owned: true,  price: 0,   brand: 'Zalando',      wardrobeId: 'w3', partnerProductId: null },
      { id: 'i4', emoji: '👜', label: 'Pochette',  owned: false, price: 340, brand: 'Net-a-Porter', wardrobeId: null, partnerProductId: 'pp8' },
    ],
    aiTip: '"Un rouge à lèvres bordeaux et des boucles dorées sublimeront cette tenue ce soir."',
  },
  {
    id: '2', name: 'Tailleur nuit', tag: 'Dîner chic',
    score: 88, occasion: 'soiree', totalPrice: 209, missingPrice: 55,
    items: [
      { id: 'i5', emoji: '🧥', label: 'Blazer',    owned: true,  price: 0,  brand: 'Zara',    wardrobeId: 'w2',  partnerProductId: null },
      { id: 'i6', emoji: '👖', label: 'Pantalon',  owned: true,  price: 0,  brand: 'Mango',   wardrobeId: 'w4',  partnerProductId: null },
      { id: 'i7', emoji: '👠', label: 'Escarpins', owned: false, price: 65, brand: 'Zalando', wardrobeId: null,  partnerProductId: 'pp2' },
    ],
    aiTip: '"Votre morphologie longiligne se prête parfaitement aux coupes structurées."',
  },
  {
    id: '3', name: 'Robe fluide', tag: 'Dîner romantique',
    score: 82, occasion: 'diner', totalPrice: 175, missingPrice: 89,
    items: [
      { id: 'i8',  emoji: '🥻', label: 'Robe',    owned: true,  price: 0,  brand: 'Sézane', wardrobeId: 'w7',  partnerProductId: null },
      { id: 'i9',  emoji: '👜', label: 'Sac',     owned: true,  price: 0,  brand: 'ASOS',   wardrobeId: 'w6',  partnerProductId: null },
      { id: 'i10', emoji: '👠', label: 'Mules',   owned: false, price: 49, brand: 'Mango',  wardrobeId: null,  partnerProductId: 'pp14' },
    ],
    aiTip: '"Les teintes ivoires flatteront votre carnation ce soir."',
  },
  {
    id: '4', name: 'Chic minimaliste', tag: 'Sortie déjeuner',
    score: 84, occasion: 'sortie', totalPrice: 149, missingPrice: 89,
    items: [
      { id: 'i11', emoji: '🧣', label: 'Foulard',  owned: true,  price: 0,  brand: 'H&M',     wardrobeId: 'w5',  partnerProductId: null },
      { id: 'i12', emoji: '🧥', label: 'Trench',   owned: false, price: 89, brand: 'ASOS',    wardrobeId: null,  partnerProductId: 'pp6' },
      { id: 'i13', emoji: '👟', label: 'Sneakers', owned: true,  price: 0,  brand: 'ASOS',    wardrobeId: 'w8',  partnerProductId: null },
    ],
    aiTip: '"Un look décontracté qui reste élégant pour une sortie en journée."',
  },
  {
    id: '5', name: 'Bureau raffiné', tag: 'Réunion importante',
    score: 91, occasion: 'work', totalPrice: 158, missingPrice: 79,
    items: [
      { id: 'i14', emoji: '🧥', label: 'Blazer',   owned: true,  price: 0,  brand: 'Mango',   wardrobeId: 'w2',  partnerProductId: null },
      { id: 'i15', emoji: '👖', label: 'Pantalon', owned: true,  price: 0,  brand: 'Mango',   wardrobeId: 'w4',  partnerProductId: null },
      { id: 'i16', emoji: '👜', label: 'Sac',      owned: false, price: 79, brand: 'Mango',   wardrobeId: null,  partnerProductId: 'pp3' },
    ],
    aiTip: '"Un tailleur structuré avec une touche dorée pour marquer votre présence."',
  },
  {
    id: '6', name: 'Casual chic', tag: 'Week-end détendu',
    score: 79, occasion: 'casual', totalPrice: 109, missingPrice: 50,
    items: [
      { id: 'i17', emoji: '👚', label: 'Top',       owned: true,  price: 0,  brand: 'Sézane', wardrobeId: 'w11', partnerProductId: null },
      { id: 'i18', emoji: '👖', label: 'Jean',      owned: true,  price: 0,  brand: 'ASOS',   wardrobeId: 'w13', partnerProductId: null },
      { id: 'i19', emoji: '👟', label: 'Sneakers',  owned: false, price: 55, brand: 'ASOS',   wardrobeId: null,  partnerProductId: 'pp4' },
    ],
    aiTip: '"La simplicité bien portée est la vraie élégance."',
  },
];

/* ─── Cart ──────────────────────────────────────────────────── */
export const cartItems = [
  { id: 'c1', emoji: '👗', name: 'Robe soirée satin',  brand: 'Net-a-Porter', partnerId: 'net_a_porter', size: 'T.38', price: 480, image: 'https://images.unsplash.com/photo-1623609163859-ca93c959b98a?w=200&q=80', highlight: true  },
  { id: 'c2', emoji: '👠', name: 'Escarpins stiletto', brand: 'Zalando',      partnerId: 'zalando',      size: 'T.38', price: 65,  image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=200&q=80', highlight: false },
  { id: 'c3', emoji: '💍', name: 'Collier chaîne fine',brand: 'ASOS',         partnerId: 'asos',         size: 'Unique', price: 22, image: null, highlight: false },
];

/* ─── User Profile ──────────────────────────────────────────── */
export const userProfile = {
  name: 'Sofia', city: 'Paris', temp: '18°C', initials: 'S', plan: 'Premium',
  since: 'Janvier 2026',
  stats: { looks: 24, commandes: 8, pieces: wardrobe.length },
  preferences: {
    styles:  ['Chic', 'Soirée', 'Élégant'],
    colors:  ['Noir', 'Or', 'Ivoire', 'Bordeaux'],
    marques: ['Sézane', 'Net-a-Porter', 'Zalando'],
    budget:  'Premium (200–500 €)',
  },
};

/* ─── Catégories IA — pour la classification automatique ─────── */
export const AI_CATEGORIES = {
  'Robes':       { keywords: ['robe','dress','midi','maxi','mini'], emoji: '👗' },
  'Hauts':       { keywords: ['top','chemise','blouse','shirt','tshirt'], emoji: '👚' },
  'Vestes':      { keywords: ['veste','blazer','jacket','bomber','perfecto','cardigan','denim jacket'], emoji: '🧥' },
  'Manteaux':    { keywords: ['manteau','trench','caban','parka','doudoune','pardessus','duffle','coat','overcoat'], emoji: '🧥' },
  'Bas':         { keywords: ['pantalon','jean','jupe','shorts','skirt'], emoji: '👖' },
  'Chaussures':  { keywords: ['chaussure','escarpins','sneakers','boots','talon','mule'], emoji: '👠' },
  'Sacs':        { keywords: ['sac','pochette','bag','clutch','cabas'], emoji: '👜' },
  'Accessoires': { keywords: ['écharpe','foulard','ceinture','lunettes','chapeau','gants'], emoji: '🧣' },
  'Bijoux':      { keywords: ['collier','bague','bracelet','boucle','bijou','jewelry'], emoji: '💍' },
};

export const AI_COLORS = ['Noir','Blanc','Beige','Camel','Ivoire','Bordeaux','Bleu','Rouge','Rose','Vert','Gris','Or','Argent','Multicolore'];
export const AI_STYLES = ['Soirée','Bureau','Casual','Sport','Chic','Bohème','Streetwear'];
